import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { roleId } from '../../constants/app';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { updateOrderFromTable } from '../../action/orders';

const CourierSelector = ({
    item,    
    openClient,
    isArchive,
    isDisabled
}) => {
    const loadingUpdateorder = useSelector(state => state.loaders.updateorder);
    const loadingFilials = useSelector(state => state.loaders.filials);
    const user = useSelector(state => state.user.info);
    const couriers = useSelector(state => state.users.couriers);
    const loadingCourier = useSelector(state => state.loaders.couriers);
    const [couriersPoint, setCouriersPoint] = useState([]);
    const dispatch = useDispatch();

    const renderCourierLabel = (courier) => {
        if (!courier) return null;
        return courier.name || courier.username || 'Имя не определено';
    };

    useEffect(() => {
        let point = null;

        if (item.point && item.point.id) {
            point = item.point;
        } else if (item.zone && item.zone.point && item.zone.point.id) {
            point = item.zone.point;
        }

        const result = couriers
        .filter((el) => el.allPoints || (el.points && point && el.points.some(filial => filial.id === point.id)))
        .map((item) => ({
            value: {
                name: renderCourierLabel(item),
                id: item.id
            },
            label: renderCourierLabel(item)
        }));

        result.unshift({
            value: { name: null, id: null },
            label: 'Снять назначение с курьера'
        });

        setCouriersPoint(result);
    }, [item, couriers]);


    const changeCourier = (value, item) => {
        if (user.role.id === roleId.courier) return null;
        if(item.courierId !== value.id)
        {
            const data = {
                courierName: value.name,
                courierId: value.id,
                ignoreFiscalized: true,
                ignoreConsumption: true,
            };

            let checkChangeLog = null

            if(item.changeLog) {
                if(typeof item.changeLog === 'string') {
                    checkChangeLog = JSON.parse(item.changeLog)
                } else {
                    checkChangeLog = item.changeLog
                }
            }

            const date = new Date();
            const logName = String(value + '-' + (item.changeLog ? item.changeLog.length : 0) + '__' + moment(date).format('DD.MM.YYYY'));
            let log = null;

            if (value && value.id) {
                if (item.courierId) {
                    log = `Курьер изменен с ${item.courierName} на ${value.name}`;
                } else {
                    log = `Назначен курьер ${value.name}`;
                }
            } else {
                if (item.courierId) log = `Снято назначение с курьера ${item.courierName}`;
            }

            if (log !== null) {
                data.changeLog = {
                    ...checkChangeLog,
                    [logName]: {
                        courier: log,
                        date: moment(date).format('DD.MM.YYYY HH:mm'),
                        user: user.username
                    }
                };
            };

            return dispatch(updateOrderFromTable(item.id, data, isArchive ));
        }
    }

  return (
    <div className='order_table_selector courier'>
      <Select
        isLoading={loadingCourier || loadingFilials || loadingUpdateorder === item.id}
        isDisabled={isDisabled || user.role.id === roleId.courier || loadingCourier || openClient || loadingFilials || loadingUpdateorder === item.id || (user.role.id !== roleId.admin && ['written-off', 'cancel'].includes(item.status))}
        value={item.courierName ? {label: item.courierName, value: item.courierName} : null}
        closeMenuOnSelect={true}
        classNamePrefix='order_table_courier_select'
        onChange={(e) => {changeCourier(e ? e.value : null, item)}}
        styles={{menuPortal: base => ({...base, zIndex: 9999})}}
        menuPlacement="auto"
        options={couriersPoint}
        placeholder="Курьер"
        noOptionsMessage={() => 'Курьеры не найдены'}
      />
    </div>
  );
};


export default CourierSelector;